import {createFileRoute} from '@tanstack/react-router'

import {zeroLevelIndexRoute} from "../../../../../utils/collectionListing";

export const Route = createFileRoute('/_site/users/_public_profile/wants/$username/')({
    ...zeroLevelIndexRoute("/users/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName")
});

